module.exports = __webpack_public_path__ + "static/media/0324_IMG_LE_CHARCUTIER.96058b5e.png";